import NotificationApi from '@apis/notification/NotificationApi';
import queries from '@apis/queries';
import { GetNotificationsParams } from '@models/notification';
import { useInfiniteQuery } from '@tanstack/react-query';

function useNotifications() {
    const params: Omit<GetNotificationsParams, 'page'> = {
        size: 20,
    };
    const queryInfo = useInfiniteQuery({
        queryKey: queries.notifications.list(params).queryKey,
        initialPageParam: 0,
        queryFn: ({ pageParam }) => NotificationApi.getNotifications({
            ...params,
            page: pageParam,
        }),
        getNextPageParam: (lastPage) => (lastPage.slice?.last ? undefined
            : lastPage.slice.currentPage + 1),
    });
    const notifications = queryInfo.data
        ?.pages.map((it) => it.content)
        .flat();
    const isBlank = queryInfo.isFetched && notifications?.length === 0;

    return {
        ...queryInfo,
        notifications,
        isBlank,
    };
}

export default useNotifications;
